import { useEffect, useState } from "react";
import api from "../api";
import * as XLSX from "xlsx-js-style";

const API = process.env.REACT_APP_API_URL;

function Reports() {

  const [data, setData] = useState([]);
  const [showDefaulters, setShowDefaulters] = useState(false);
  const getCurrentMonth = () => {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    return months[new Date().getMonth()];
  };

  const monthMap = {
    April: 1, May: 2, June: 3, July: 4,
    August: 5, September: 6, October: 7,
    November: 8, December: 9, January: 10,
    February: 11, March: 12
  };

  const allMonths = [
    "April", "May", "June", "July", "August",
    "September", "October", "November", "December",
    "January", "February", "March"
  ];

  const currentMonth2 = getCurrentMonth();

  const monthsCount = monthMap[currentMonth2] || 1;
  const currentIndex = allMonths.indexOf(currentMonth2);

  const startMonth = allMonths[0];
  const endMonth = allMonths[currentIndex] || "April";

  const [currentMonth, setCurrentMonth] = useState(getCurrentMonth());
  const [selectedClass, setSelectedClass] = useState("");
  const [sortBy, setSortBy] = useState("class_asc");


  const classOrder = {
    "Nursery": 1,
    "LKG": 2,
    "UKG": 3,
    "One": 4,
    "Two": 5,
    "Three": 6,
    "Four": 7,
    "Five": 8,
    "Six": 9,
    "Seven": 10,
    "Eight": 11,
    "Nine": 12,
    "Ten": 13
  };





  useEffect(() => {
    api.get("/advanced-report")
      .then(res => setData(res.data))
      .catch(err => console.log(err));
  }, []);

  const format = (num) =>
    new Intl.NumberFormat("en-IN").format(num);

  let filteredData = selectedClass
    ? data.filter(d => d.Class === selectedClass)
    : data;

  // ✅ ADD THIS FILTER
  if (showDefaulters) {
    filteredData = filteredData.filter(row =>
      Number(row.TuitionDue || 0) +
      Number(row.TransportDue || 0) +
      Number(row.ExamDue || 0) +
      Number(row.AdmissionDue || 0) > 0
    );
  }



  if (sortBy === "adm_asc") {
    filteredData.sort((a, b) => {

      // 1️⃣ Class order first
      const classDiff =
        (classOrder[a.Class] || 999) -
        (classOrder[b.Class] || 999);

      if (classDiff !== 0) return classDiff;

      // 2️⃣ Then Admission No
      return a.AdmNo - b.AdmNo;
    });
  }

  if (sortBy === "class_asc") {
    filteredData.sort((a, b) => {

      // 1️⃣ Class order
      const classDiff =
        (classOrder[a.Class] || 999) -
        (classOrder[b.Class] || 999);

      if (classDiff !== 0) return classDiff;

      // 2️⃣ Name inside class
      return a.Name.localeCompare(b.Name);
    });
  }

  const grouped = {};
  filteredData.forEach(row => {
    const key = `${row.Class}-${row.Section}`;
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(row);
  });

  const totalStudents = filteredData.length;




  const totals = filteredData.reduce((acc, row) => {
    acc.tuition += Number(row.TuitionDue || 0);
    acc.transport += Number(row.TransportDue || 0);
    acc.exam += Number(row.ExamDue || 0);
    acc.admission += Number(row.AdmissionDue || 0);
    return acc;
  }, { tuition: 0, transport: 0, exam: 0, admission: 0 });

  const totalExpected = filteredData.reduce((sum, row) =>
    sum + Number(row.TotalExpected || 0)
    , 0);

  const totalDues = filteredData.reduce((sum, row) => {
    return sum + (
      Number(row.TuitionDue || 0) +
      Number(row.TransportDue || 0) +
      Number(row.ExamDue || 0) +
      Number(row.AdmissionDue || 0)
    );
  }, 0);

  const totalReceived = filteredData.reduce((sum, row) =>
    sum + Number(row.TotalPaid || 0)
    , 0);

  const totalConcession = filteredData.reduce((sum, row) =>
    sum + Number(row.TotalConcession || 0)
    , 0);

  const totalAdvance = filteredData.reduce((sum, row) =>
    sum + Number(row.TotalAdvance || 0)
    , 0);

  const handleExport = () => {

    const wb = XLSX.utils.book_new();
    const rows = [];

    rows.push([`Period: ${monthsCount} Months (${startMonth} → ${endMonth})`]);
    rows.push([]);

    // 🔹 GRAND TOTAL VARIABLES

    let grandDueAll = 0;

    Object.keys(grouped).forEach(group => {

      // 🟨 Class Header
      rows.push([`Class: ${group}`]);
      rows.push([]);

      const headerRow = [
        "AdmNo",
        "Name",
        "Tuition Due",
        "Transport Due",
        "Exam Due",
        "Admission Due",
        "Total Due"
      ];

      rows.push(headerRow);


      let totalDueAll = 0;

      grouped[group].forEach(row => {



        const tuitionDue = Number(row.TuitionDue || 0);
        const transportDue = Number(row.TransportDue || 0);
        const examDue = Number(row.ExamDue || 0);
        const admissionDue = Number(row.AdmissionDue || 0);

        const totalDue =
          tuitionDue +
          transportDue +
          examDue +
          admissionDue;






        totalDueAll += totalDue;



        grandDueAll += totalDue;

        rows.push([
          row.AdmNo,
          row.Name,
          row.TuitionDue || 0,
          row.TransportDue || 0,
          row.ExamDue || 0,
          row.AdmissionDue || 0,
          row.TotalDue || 0
        ]);
      });

      const colCount = headerRow.length;
      const empty = new Array(colCount).fill("");

      rows.push([]);



      // 🔹 CLASS TOTAL ROWS (values in Column C)
      rows.push([
        "",
        "TOTAL DUE",
        ...empty.slice(2, headerRow.length - 1),
        totalDueAll
      ]);

      rows.push([]);
      rows.push([]);
    });

    // 🔹 GRAND TOTAL SECTION
    const colCount = rows[2].length;
    const empty = new Array(colCount).fill("");



    rows.push([]);
    rows.push(["GRAND TOTAL"]);
    rows.push([]);

    rows.push([
      "",
      "TOTAL DUE",
      ...empty.slice(2, colCount - 1),
      grandDueAll
    ]);

    const ws = XLSX.utils.aoa_to_sheet(rows);

    Object.keys(ws).forEach(cell => {
      if (cell[0] === "!") return;

      const value = ws[cell].v;

      // Detect percentage values (0–1 range)
      if (typeof value === "number" && value > 0 && value <= 1) {
        ws[cell].z = "0.0%"; // Excel format
      }
    });


    Object.keys(ws).forEach(cell => {
      if (cell[0] === "!") return;

      const col = cell.match(/[A-Z]+/)[0];
      const row = parseInt(cell.match(/\d+/)[0]);
      const value = ws[cell].v;

      const labelCells = [
        "TOTAL EXPECTED",
        "TOTAL CONCESSION",
        "TOTAL PAID",
        "TOTAL DUE",
        "% COLLECTION"
      ];

      const isTotalRow =
        ws["B" + row] && labelCells.includes(ws["B" + row].v);

      // 🔹 TOTAL ROW SPECIAL HANDLING
      if (isTotalRow) {

        ws[cell].s = {
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" }
          },
          font: { bold: true },
          fill: { fgColor: { rgb: "FFF2CC" } }
        };

        return;
      }

      // 🔹 NORMAL TABLE CELLS
      ws[cell].s = {
        border: {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" }
        }
      };

      // Header
      if (row === 3) {
        ws[cell].s = {
          ...ws[cell].s,
          font: { bold: true },
          fill: { fgColor: { rgb: "E5E7EB" } }
        };
      }

      // % formatting ONLY for % COLLECTION
      if (
        typeof value === "number" &&
        ws["B" + row] &&
        ws["B" + row].v === "% COLLECTION"
      ) {
        ws[cell].z = "0.0%";
      }
    });

    // Column widths
    ws["!cols"] = [
      { wch: 8 },
      { wch: 20 },
      { wch: 12 },
      ...Array(20).fill({ wch: 8 }),
      { wch: 12 }
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Dues Report");

    XLSX.writeFile(wb, "Dues_Report.xlsx");
  };

  const handlePrint = () => {
    window.print();
  };

  const defaultersCount = filteredData.filter(row =>
    Number(row.TuitionDue || 0) +
    Number(row.TransportDue || 0) +
    Number(row.ExamDue || 0) +
    Number(row.AdmissionDue || 0) > 0
  ).length;

  const percent =
    totalExpected > 0
      ? (totalReceived / totalExpected) * 100
      : 0;

  return (
    <div className="print-area" style={{ padding: "25px", maxWidth: "1200px", margin: "auto" }}>

      <h2>
        {showDefaulters ? "Defaulters Report" : "Dues Report"}
        <span style={{ fontSize: "14px", marginLeft: "10px", color: "#6b7280" }}>
          ({monthsCount} Months: {startMonth} → {endMonth})
        </span>
      </h2>

      <div className="no-print" style={filterBar}>

        <div style={filterLeft}>


          <select
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
            style={selectStyle}
          >
            <option value="">All Classes</option>
            {[...new Set(data.map(d => d.Class))].map(c => (
              <option key={c}>{c}</option>
            ))}
          </select>

          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            style={selectStyle}
          >
            <option value="">Sort By</option>
            <option value="due_desc">Highest Due</option>
            <option value="adm_asc">Admission No</option>
            <option value="class_asc">Class Order</option>
          </select>

          <label style={{
            marginLeft: "15px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            fontSize: "14px",
            cursor: "pointer"
          }}>
            <input
              type="checkbox"
              checked={showDefaulters}
              onChange={(e) => setShowDefaulters(e.target.checked)}
              style={{ cursor: "pointer" }}
            />
            Show Defaulters Only
          </label>
        </div>

        <div style={filterRight}>
          <button onClick={handleExport} style={exportBtn}>
            ⬇ Export
          </button>

          <button onClick={handlePrint} style={printBtn}>
            🖨 Print
          </button>
        </div>

      </div>

      <div style={{ marginBottom: "15px" }}>
        <b>Total Students:</b> {totalStudents} &nbsp;&nbsp;
        <b>Defaulters:</b> <span style={{ color: "red" }}>{defaultersCount}</span> &nbsp;&nbsp;
        <b>Total Dues:</b> ₹{format(totalDues)}
      </div>

      <div style={{
        display: "flex",
        gap: "20px",
        marginBottom: "20px",
        flexWrap: "wrap"
      }}>

        <div style={{
          background: "#eef6ff",
          padding: "15px",
          borderRadius: "12px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          marginBottom: "20px"
        }}>

          {/* 🔷 Title */}
          <div style={{
            fontWeight: "bold",
            marginBottom: "12px",
            fontSize: "16px",
            color: "#1d4ed8"
          }}>
            COLLECTION
          </div>

          {/* 🔷 Cards Row */}
          <div style={{
            display: "flex",
            gap: "20px",
            flexWrap: "wrap"
          }}>

            {/* Total Expected */}
            <div style={{ ...cardStyle, background: "#e0f2fe" }}>
              <div>Total Expected</div>
              <b style={{ color: "#0369a1" }}>
                ₹{format(totalExpected)}
              </b>
            </div>

            {/* Total Received */}
            <div style={{ ...cardStyle, background: "#dcfce7" }}>
              <div>Total Received</div>
              <b style={{ color: "#166534" }}>
                ₹{format(totalReceived)}
              </b>
            </div>

            {/* Advance */}
            <div style={{ ...cardStyle, background: "#ede9fe" }}>
              <div>Advance Payment</div>
              <b style={{ color: "#5b21b6" }}>
                ₹{format(totalAdvance)}
              </b>
            </div>

            {/* Concession */}
            <div style={{ ...cardStyle, background: "#fef3c7" }}>
              <div>Total Concession</div>
              <b style={{ color: "#92400e" }}>
                ₹{format(totalConcession)}
              </b>
            </div>

          </div>

          <div style={{
            marginTop: "10px",
            fontSize: "16px",
            fontWeight: "bold",
            color:
              percent < 50 ? "#dc2626" :
                percent < 80 ? "#d97706" :
                  "#16a34a"
          }}>
            Collection: {percent.toFixed(1)}%
          </div>

        </div>

        <div style={{
          background: "#fef2f2",   // light red tone
          padding: "15px",
          borderRadius: "12px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          marginBottom: "20px"
        }}>

          {/* 🔹 Title */}
          <div style={{
            fontWeight: "bold",
            marginBottom: "12px",
            fontSize: "16px",
            color: "#b91c1c"
          }}>
            DUES BREAKDOWN
          </div>

          {/* 🔹 Cards */}
          <div style={{
            display: "flex",
            gap: "20px",
            flexWrap: "wrap"
          }}>

            {/* Tuition */}
            <div style={duesCardStyle}>
              <div>Tuition</div>
              <b>₹{format(totals.tuition)}</b>
            </div>

            {/* Transport */}
            <div style={duesCardStyle}>
              <div>Transport</div>
              <b>₹{format(totals.transport)}</b>
            </div>

            {/* Exam */}
            <div style={duesCardStyle}>
              <div>Exam</div>
              <b>₹{format(totals.exam)}</b>
            </div>

            {/* Admission */}
            <div style={duesCardStyle}>
              <div>Admission</div>
              <b>₹{format(totals.admission)}</b>
            </div>

          </div>

          {/* 🔴 TOTAL */}
          <div style={{
            marginTop: "15px",
            padding: "12px",
            background: "#fee2e2",
            borderRadius: "8px",
            textAlign: "center",
            fontWeight: "bold"
          }}>
            TOTAL DUE ₹{format(totalDues)}
          </div>


        </div>

      </div>

      {
        Object.keys(grouped)
          .sort((a, b) => {

            // 🔥 HIGHEST DUE (CLASS LEVEL)
            if (sortBy === "due_desc") {

              const totalA = grouped[a].reduce((sum, row) =>
                sum +
                Number(row.TuitionDue || 0) +
                Number(row.TransportDue || 0) +
                Number(row.ExamDue || 0) +
                Number(row.AdmissionDue || 0)
                , 0);

              const totalB = grouped[b].reduce((sum, row) =>
                sum +
                Number(row.TuitionDue || 0) +
                Number(row.TransportDue || 0) +
                Number(row.ExamDue || 0) +
                Number(row.AdmissionDue || 0)
                , 0);

              return totalB - totalA; // highest first
            }


            // ✅ CLASS ORDER 
            if (sortBy === "class_asc") {

              const [classA, sectionA] = a.split("-");
              const [classB, sectionB] = b.split("-");

              // 1️⃣ Class order
              const classDiff =
                (classOrder[classA] || 999) -
                (classOrder[classB] || 999);

              if (classDiff !== 0) return classDiff;

              // 2️⃣ Section order
              return sectionA.localeCompare(sectionB);
            }

            return 0;
          })
          .map(group => {

            if (sortBy === "due_desc") {
              grouped[group].sort((a, b) =>
                (b.TotalDue || 0) - (a.TotalDue || 0)
              );
            }



            if (sortBy === "adm_asc") {
              grouped[group].sort((a, b) => a.AdmNo - b.AdmNo);
            }

            if (sortBy === "class_asc") {
              grouped[group].sort((a, b) =>
                a.Name.localeCompare(b.Name)
              );
            }

            let totalDueAll = 0;
            // ✅ ADD HERE
            let tSum = 0, trSum = 0, eSum = 0, aSum = 0;

            grouped[group].forEach(row => {
              tSum += Number(row.TuitionDue || 0);
              trSum += Number(row.TransportDue || 0);
              eSum += Number(row.ExamDue || 0);
              aSum += Number(row.AdmissionDue || 0);
            });

            return (
              <div key={group} style={{ marginBottom: "25px" }}>
                <h3>{group}</h3>

                <p style={{ color: "#6b7280", fontSize: "13px" }}>
                  Students: {grouped[group].length}
                </p>

                <table style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "14px"
                }}>
                  <thead style={{
                    borderBottom: "2px solid #d1d5db",
                  }}>
                    <tr>
                      <th style={thStyle}>Adm No</th>
                      <th style={thStyle}>Name</th>
                      <th style={thStyle}>Tuition Due</th>
                      <th style={thStyle}>Conveyance Due</th>
                      <th style={thStyle}>Exam Due</th>
                      <th style={thStyle}>Admission Due</th>
                      <th style={thStyle}>Total Due</th>
                    </tr>
                  </thead>

                  <tbody>

                    {grouped[group].map(row => {

                      const tuitionDue = Number(row.TuitionDue || 0);
                      const transportDue = Number(row.TransportDue || 0);
                      const examDue = Number(row.ExamDue || 0);
                      const admissionDue = Number(row.AdmissionDue || 0);

                      const totalDue =
                        tuitionDue +
                        transportDue +
                        examDue +
                        admissionDue;



                      totalDueAll += totalDue;

                      return (
                        <tr
                          key={row.AdmNo}
                          style={{ cursor: "pointer", borderBottom: "1px solid #e5e7eb" }}
                          onMouseEnter={e => e.currentTarget.style.background = "#f9fafb"}
                          onMouseLeave={e => e.currentTarget.style.background = ""}
                        >
                          <td style={{ borderLeft: "none", padding: "10px" }}>{row.AdmNo}</td>
                          <td style={{ padding: "10px" }}>{row.Name}</td>

                          <td style={{ textAlign: "right", paddingRight: "12px", fontWeight: "bold", color: tuitionDue > 0 ? "#dc2626" : "#6b7280" }}>
                            ₹{format(tuitionDue)}
                          </td>

                          <td style={{ textAlign: "right", paddingRight: "12px", fontWeight: "bold", color: transportDue > 0 ? "#dc2626" : "#6b7280" }}>
                            ₹{format(transportDue)}
                          </td>

                          <td style={{ textAlign: "right", paddingRight: "12px", fontWeight: "bold", color: examDue > 0 ? "#dc2626" : "#6b7280" }}>
                            ₹{format(examDue)}
                          </td>

                          <td style={{ textAlign: "right", paddingRight: "12px", fontWeight: "bold", color: admissionDue > 0 ? "#dc2626" : "#6b7280" }}>
                            ₹{format(admissionDue)}
                          </td>



                          <td style={{ fontWeight: "bold", paddingRight: "12px", color: totalDue > 0 ? "#dc2626" : "#111", textAlign: "right" }}>
                            ₹{format(totalDue)}
                          </td>
                        </tr>
                      );
                    })}

                    <tr style={{
                      fontWeight: "bold",
                      background: "#f3f4f6",
                      borderTop: "2px solid #ccc"
                    }}>
                      <td colSpan="2" style={{ textAlign: "right", paddingRight: "12px" }}>
                        TOTAL
                      </td>

                      <td style={{ textAlign: "right", paddingRight: "12px" }}>
                        ₹{format(tSum)}
                      </td>

                      <td style={{ textAlign: "right", paddingRight: "12px" }}>
                        ₹{format(trSum)}
                      </td>

                      <td style={{ textAlign: "right", paddingRight: "12px" }}>
                        ₹{format(eSum)}
                      </td>

                      <td style={{ textAlign: "right", paddingRight: "12px" }}>
                        ₹{format(aSum)}
                      </td>

                      <td style={{
                        textAlign: "right",
                        paddingRight: "12px",
                        color: "#dc2626"
                      }}>
                        ₹{format(totalDueAll)}
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            );
          })}
    </div>
  );
}

const filterBar = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: "#ffffff",
  padding: "12px 15px",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  marginBottom: "20px"
};

const filterLeft = {
  display: "flex",
  gap: "10px"
};

const filterRight = {
  display: "flex",
  gap: "10px"
};

const selectStyle = {
  padding: "8px 12px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "14px",
  cursor: "pointer"
};

const exportBtn = {
  padding: "8px 15px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer"
};

const printBtn = {
  padding: "8px 15px",
  background: "#16a34a",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer"
};

const cardStyle = {
  background: "#ffffff",
  padding: "12px 18px",
  borderRadius: "8px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
  minWidth: "180px",
  textAlign: "center"
};

const thStyle = {
  background: "#f3f4f6",
  padding: "10px",
  borderBottom: "1px solid #030b16",
  textAlign: "center",
  borderLeft: "1px solid #f1f5f9"
};

const tdStyle = {
  padding: "10px",
  borderBottom: "1px solid #010408",
  textAlign: "center"
};

const duesCardStyle = {
  ...cardStyle,
  background: "#fff7f7",
  border: "1px solid #fee2e2",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06)"
};

export default Reports;